__turbopack_context__.v({
  "accessibility_icons_icons": "T_7hda_accessibility_icons_icons",
  "icon": "T_7hda_icon",
});
